import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";


export default function WartungsprotokollSeite6({ form, setForm }) {

    const [showZusatz1, setShowZusatz1] = useState(false);
    const [showZusatz2, setShowZusatz2] = useState(false);

  if (!form) return null;

  // helper for zusatz-tables fields (text + checkbox)
  const updateZusatz = (table, index, field, value) => {
    setForm(prev => {
      const updated = [...(prev[table] || [])];
      updated[index] = { ...(updated[index] || {}), [field]: value };
      return { ...prev, [table]: updated };
    });
  };

  return (
    
    <div className="p-6 text-sm">
      {/* ================= SECTION 7 ================= */}
      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
      <h2 style={{ fontWeight: "bold" }}>7 Prüfung WR</h2>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
          <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {[
            "7.1 Alle WR sind frei und zugänglich",
            "7.2 Alle WR sind funktionsfähig und speisen ein, ohne Fehlermeldungen",
            "7.3 Alle DC-Stecker sind richtig angeschlossen an den WR",
            "7.4 Die Lüfter / Kühler / Staubfilter aller WR sind in Ordnung und sauber",
            "7.5 Die DC-Schalter der WR sind alle in Ordnung",
            "7.6 Die Beschriftung der Wechselrichter ist Ordnung",
            "7.7 Der innerliche Zustand der WR ist in Ordnung",
            "7.8 Der äußerliche Zustand der WR ist in Ordnung",
            "7.9 Die Kabelverschraubungen sind fest und dicht",
            "7.10 Die Netzfreischaltstellen der WR sind alle in Ordnung",
            "7.11 Die Phasensymmetrieüberwachung der WR ist in Ordnung",
            "7.12 Aufsteller / Montagestelle der WR sind alle in Ordnung",
            "7.13 Der Diebstahlschutz der WR ist vorhanden und frei von Schäden",
            "7.14 Die WR wurden gereinigt (Foto Verschmutzungsgrad!)"
          ].map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
              
                <input
                  type="checkbox"
                  checked={!!form.pruefungWR?.[idx]?.ja}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungWR || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungWR: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
              
                <input
                  type="checkbox"
                  checked={!!form.pruefungWR?.[idx]?.nein}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungWR || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungWR: list };
                    })
                  }
                />
              </td>

              {/* n.z. */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
           
                <input
                  type="checkbox"
                  checked={!!form.pruefungWR?.[idx]?.nz}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungWR || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungWR: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

             <Box mb={3} mt={4}>
            
                    <Button
                      onClick={() => setShowZusatz1(!showZusatz1)}
                      colorScheme="blue"
                      borderRadius="lg"
                    >
                      {showZusatz1 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
                    </Button>
            
               </Box>
      
      {/* ============ ZUSATZ-TABELLE #1 ============ */}
       {showZusatz1 && (
        <>
      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen / Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {(form.zusatzWR ?? Array.from({ length: 5 }, () => ({
            zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false
          }))).map((row, idx) => (
            <tr key={idx}>
              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row?.[field] ?? ""}
                    onChange={e => updateZusatz("zusatzWR", idx, field, e.target.value)}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#f7f7fb",
                      height: "18px"
                    }}
                  />
                </td>
              ))}

              <td style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={!!row?.plan}
                  onChange={() => updateZusatz("zusatzWR", idx, "plan", !row?.plan)}
                />
              </td>

              <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                <input
                  type="text"
                  value={row?.bildnr ?? ""}
                  onChange={e => updateZusatz("zusatzWR", idx, "bildnr", e.target.value)}
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f7f7fb",
                    height: "18px"
                  }}
                />
              </td>

              {["beh", "nbeh"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={!!row?.[field]}
                    onChange={() => updateZusatz("zusatzWR", idx, field, !row?.[field])}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
        </>
       )}
      </Box>

      {/* ================= SECTION 8 ================= */}

      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
      <h2 style={{ fontWeight: "bold" }}>8 Prüfung AC-Verteiler</h2>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {[
            "8.1 Die Verteiler sind frei und zugänglich",
            "8.2 Die Automaten/WR-Sicherungen / FI-Schalter sind alle funktionsfähig",
            "8.3 Die Hauptsicherungen sind alle funktionsfähig und richtig montiert",
            "8.4 Die Sicherungen für das ÜSS sind funktionsfähig und richtig montiert",
            "8.5 Die ÜSS-Einrichtungen sind alle funktionsfähig",
            "8.6 Die Verteiler sind frei von Schäden",
            "8.7 Der innerliche Zustand der Verteiler ist in Ordnung / frei von Feuchtigkeit",
            "8.8 Die Erdung der Verteiler ist frei von Schäden und richtig montiert",
            "8.9 Die Beschriftung der Verteiler ist in Ordnung",
            "8.10 Die Kabelverschraubungen sind fest und dicht",
            "8.11 Die Anzugsmomente aller Schrauben sind richtig (Kabelanschlüsse)",
            "8.12 Keine Auffälligkeiten durch die Thermografieuntersuchung der Vert.",
            "8.13 AC-Messungen wurden durchgeführt (Verdacht / Teilbereich / vollständig)"
          ].map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={!!form.pruefungAC?.[idx]?.ja}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungAC || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungAC: list };
                    })
                  }
                />
              </td>

              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={!!form.pruefungAC?.[idx]?.nein}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungAC || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungAC: list };
                    })
                  }
                />
              </td>

              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
               
                <input
                  type="checkbox"
                  checked={!!form.pruefungAC?.[idx]?.nz}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungAC || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungAC: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

           <Box mb={3} mt={4}>
            
                    <Button
                      onClick={() => setShowZusatz2(!showZusatz2)}
                      colorScheme="blue"
                      borderRadius="lg"
                    >
                      {showZusatz2 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
                    </Button>
            
                    </Box>

      {/* ============ ZUSATZ-TABELLE #2 ============ */}
        {showZusatz2 && (
        <>
      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen / Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {(form.zusatzAC ?? Array.from({ length: 5 }, () => ({
            zupunkt: "", bemerkung: "", standort: "", plan: false, bildnr: "", beh: false, nbeh: false
          }))).map((row, idx) => (
            <tr key={idx}>
              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row?.[field] ?? ""}
                    onChange={e => updateZusatz("zusatzAC", idx, field, e.target.value)}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#f7f7fb",
                      height: "18px"
                    }}
                  />
                </td>
              ))}

              <td style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={!!row?.plan}
                  onChange={() => updateZusatz("zusatzAC", idx, "plan", !row?.plan)}
                />
              </td>

              <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                <input
                  type="text"
                  value={row?.bildnr ?? ""}
                  onChange={e => updateZusatz("zusatzAC", idx, "bildnr", e.target.value)}
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f7f7fb",
                    height: "18px"
                  }}
                />
              </td>

              {["beh", "nbeh"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={!!row?.[field]}
                    onChange={() => updateZusatz("zusatzAC", idx, field, !row?.[field])}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
       </>
       )}
      </Box>
    </div>

  );
}